import * as React from 'react';
import CodeFlagsBulk from 'Components/templates/CodeFlagsBulk';

export default function CodeFlagsBulkScreen() {
  return <CodeFlagsBulk />;
}
